<template>
  <div class="bg" v-show="show">
    <div @click="bgClose" class="greyBg"></div>
    <div v-if="showPhone && c.platformType != 'b_plus' && c.platformType != 'dy'" :style="'font-size:'+fontSize+'px'" class="phone-container">
      <img v-show="!c.noClose" @click="close" class="close" src="./assets/close.png" alt="">
      <div class="phone">
        <img class="topLine" src="./assets/phoneTop.png" alt="">
        <div class="phoneScroll">
          <video ref="fVideo" v-show="c.video_url" :src="c.video_url || ''" controls controlslist="nodownload"></video>
          <div class="title">
            <p :style="'line-height:' + 0.25 * fontSize + 'px'">{{c.title}}</p>
            <div>
              <p :style="'line-height:' + 0.16 * fontSize + 'px'">{{c.column || c.platform_title}}</p>
              <p :style="'line-height:' + 0.16 * fontSize + 'px'">{{c.raw_update_time}}</p>
            </div>
          </div>
          <div class="content">
            <div v-show="c.type == 5" :style="'line-height:' + 0.24 * fontSize + 'px'" class="article">{{c.info}}</div>
            <div v-show="c.type == 6" v-html="c.content_html || c.content" :style="'line-height:' + 0.24 * fontSize + 'px'" class="article"></div>
            <div class="arrowLine">
              <p></p>
              <img src="./assets/angle.png" alt="">
              <p></p>
            </div>

            <div v-show="c.has_copyright == 1" :style="'line-height:' + 0.24 * fontSize + 'px'" class="notice">
              <i>版权申明：</i>本文系看看新闻Knews独家稿件，未经授权，不得转载。
            </div>
          </div>

          <img class="shareIcon" src="./assets/shareIcon.png" alt="">
        </div>
        <img class="bottomLine" src="./assets/bottomIcon.png" alt="">
      </div>
    </div>
    <div v-if="!showPhone && c.platformType != 'b_plus' && c.platformType != 'dy'" class="pc-container">
      <div class="title">
        <p>{{c.title}}</p>
        <div>
          <p>{{c.column || c.platform_title}}</p>
          <p>{{c.raw_update_time}}</p>
        </div>
        <img class="threeShareIcon" src="./assets/threeShareIcon.png" alt="">
      </div>
      <div class="content">
        <video ref="aVideo" v-show="c.video_url" :src="c.video_url || ''" controls controlslist="nodownload"></video>
        <div v-show="c.type == 5" class="article">{{c.info}}</div>
        <div v-show="c.type == 6" v-html="c.content_html || c.content" class="article"></div>
        <div class="copyright" v-show="c.type == 6 && c.has_copyright == 1">版权声明：本文系看看新闻Knews独家稿件，未经授权，不得转载。</div>
      </div>
      <img v-show="!c.noClose" @click="close" class="close" src="./assets/close.png" alt="">
    </div>

    <div v-if="c.platformType == 'b_plus'" :style="'font-size:'+fontSize+'px'" class="phone-container">
      <img v-show="!c.noClose" @click="close" class="close" src="./assets/close.png" alt="">
      <div class="phone black">
        <div class="bTop">
          <i class="back"></i>
          <i class="search"></i>
        </div>
        <div class="threeBtn">
          <i class="icon"></i>
          <i class="zan"></i>
          <i class="share"></i>
        </div>
        <div class="info">
          <p :style="'line-height:'+0.17*fontSize+'px'" class="col">@{{c.column || c.platform_title}}</p>
          <p :style="'line-height:'+0.15*fontSize+'px'">{{c.title}}</p>
        </div>
        <video ref="bVideo" @click="playVideo" :src="c.video_url || ''" controlslist="nodownload"></video>
        <div class="progress">
          <p :style="'width:'+num+'%'" class="line"></p>
        </div>
      </div>
    </div>

    <div v-if="c.platformType == 'dy'" :style="'font-size:'+fontSize+'px'" class="phone-container">
      <img v-show="!c.noClose" @click="close" class="close" src="./assets/close.png" alt="">
      <div style="background: #000;" class="phone">
          <div style="height: 100vh;" class="dy-container">
            <div class="top"></div>
            <video @click="playVideo" ref="cVideo" :src="c.video_url"></video>
            <div class="message">
              <p class="name">@{{c.account_name}}</p>
              <div class="content">
                <span :class="{word: true,on: toggleShow}" v-html="c.info"></span>
                <span @click="toggleShow = !toggleShow" v-if="c.info && c.info.length > 100" class="toggle">{{toggleShow ? '展开' : '折叠'}}</span>
              </div>
              <p class="from">
                <img src="../../assets/img/dy/dyIcon.png" alt="">
                <span>@{{c.account_name}}创作的原声</span>
              </p>
            </div>
            <div class="btn">
              <div class="avatar">
                <img :src="c.logo" alt="">
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/zan.png" alt="">
                <p>2548</p>
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/comment.png" alt="">
                <p>211</p>
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/share.png" alt="">
                <p>1141</p>
              </div>
              <div class="disk">
                <img class="disk1" src="../../assets/img/dy/disk.png" alt="">
                <img class="sound" src="../../assets/img/dy/music.png" alt="">
              </div>
            </div>
            <div class="bottom"></div>
          </div> 
        </div>
    </div>

    <div v-if="c.platformType != 'b_plus' && c.platformType != 'dy'" class="switch-container">
      <div @click="showPhone = true" :class="{btn: true, un: !showPhone}">
        <img src="./assets/kankanIcon.png" alt="">
        <p>移动端</p>
      </div>
      <div @click="showPhone = false" :class="{btn: true, un: showPhone}">
        <img src="./assets/kankanIcon.png" alt="">
        <p>PC端</p>
      </div>
    </div>

    <div v-if="c.platformType == 'b_plus'" class="switch-container">
      <div :class="{btn: true, b: true}">
        <img src="./assets/bIcon.png" alt="">
        <p>移动端</p>
      </div>
    </div>

    <div v-if="c.platformType == 'dy'" class="switch-container">
      <div :class="{btn: true, b: true}">
        <img src="./assets/dIcon.png" alt="">
        <p>移动端</p>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";

export default {
  name: 'shareCode',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      toggleShow: true,
      show: true,
      fontSize: 100,
      showPhone: true,
      c: {},
      isPlay: false,
      num: 0
    }
  },
  methods: {
    playVideo() {
      // console.log(123,this.c,this.isPlay)
      if(!this.isPlay){
        if(this.c.platformType == "b_plus"){
          this.$refs.bVideo.play()
        }else if(this.c.platformType == "dy"){
          this.$refs.cVideo.play()
        }
      }else{
        if(this.c.platformType == "b_plus"){
          this.$refs.bVideo.pause()
        }else if(this.c.platformType == "dy"){
          this.$refs.cVideo.pause()
        }
      }
      this.isPlay = !this.isPlay
    },
    open(c, r) {
      // if(c.content_html){
      //   c.content = c.content_html
      // }
      let content = {};
      content = c;
      // content.content = content.content_html
      this.c = content
      // console.log(c)
      this.show = true
      this.$nextTick(() => {
        if(c.platformType == 'b_plus'){
          this.$refs.bVideo.addEventListener('ended',() => {
            this.isPlay = false;
          })
          this.$refs.bVideo.addEventListener('timeupdate',() => {
            // console.log(this.$refs.bVideo.currentTime)
            let num = this.$refs.bVideo.currentTime / this.$refs.bVideo.duration
            num = num*100
            this.num = num;
          })
        }

        this.disableContextMenu()
      })
    },
    disableContextMenu() {
      // 隐藏右键菜单
      if(this.$refs.aVideo){
        this.$refs.aVideo.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.bVideo){
        this.$refs.bVideo.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.cVideo){
        this.$refs.cVideo.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.fVideo){
        this.$refs.fVideo.oncontextmenu = function(event) {
          return false
        }
      }
    },
    bgClose() {
      if(this.c.newPreview) return
      if(this.$refs.aVideo){
        this.$refs.aVideo.pause()
      }
      if(this.$refs.bVideo){
        this.$refs.bVideo.pause()
      }
      if(this.$refs.cVideo){
        this.$refs.cVideo.pause()
      }
      if(this.$refs.fVideo){
        this.$refs.fVideo.pause()
      }
      this.show = false
    },
    close() {
      if(this.$refs.aVideo){
        this.$refs.aVideo.pause()
      }
      if(this.$refs.bVideo){
        this.$refs.bVideo.pause()
      }
      if(this.$refs.cVideo){
        this.$refs.cVideo.pause()
      }
      if(this.$refs.fVideo){
        this.$refs.fVideo.pause()
      }
      this.show = false
    },
    recalc() {
        var clientWidth = document.documentElement.clientWidth;

        if (!clientWidth) {

            return;
        }

        var p = 100 * (clientWidth / 1920);

        this.fontSize = p

        // console.log(this.$refs.bg.getBoundingClientRect().width)

        // if(this.$refs.bg.getBoundingClientRect()){
        //     this.bgHeight = this.$refs.bg.getBoundingClientRect().width * 314 / 1262
        // }
    },
    js_getDPI() {
      var arrDPI = new Array();
      if ( window.screen.deviceXDPI != undefined ) {
          arrDPI[0] = window.screen.deviceXDPI;
          arrDPI[1] = window.screen.deviceYDPI;
      }
      else {
          var tmpNode = document.createElement( "DIV" );
          tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
          document.body.appendChild( tmpNode );
          arrDPI[0] = parseInt( tmpNode.offsetWidth );
          arrDPI[1] = parseInt( tmpNode.offsetHeight );
          tmpNode.parentNode.removeChild( tmpNode );
      }
      return arrDPI;
    }
  },
  mounted() {
    let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()
  }
}
</script>

<style>
.phone-container .imgBtnsEdit {
  display: none;
}

.phone-container .imgBtnsAdd {
  display: none;
}

.pc-container .imgBtnsEdit {
  display: none;
}

.pc-container .imgBtnsAdd {
  display: none;
}
</style>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    // background: rgba(50, 59, 75, 0.3);
    // border-radius: 2px;
    // backdrop-filter: blur(1.6px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100000003;

    .greyBg {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      background: rgba(50, 59, 75, 0.3);
      border-radius: 2px;
      backdrop-filter: blur(1.6px);
    }

    .phone-container {
      position: relative;

      .close {
        position: absolute;
        top: 0em;
        right: -0.6em;
        width: 0.31em;
        height: 0.31em;
        user-select: none;
        cursor: pointer;
        z-index: 999;
      }

      .phone {
        position: relative;
        width: 3.75em;
        height: 8.12em;
        background: #FFFFFF;
        border-radius: 0.36em;
        overflow: hidden;
        padding: 0.44em 0 0.83em;
        box-sizing: border-box;

        &.black {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #000;
          padding: 0;
          width: 2.48em;
          height: 5.37em;

          .info {
            width: 90%;
            position: absolute;
            left: 0;
            bottom: 0.4em;
            padding: 0 0.15em;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            z-index: 999;

            .col {
              font-size: 0.15em;
              color: #FFF;
              margin-bottom: 0.1em;
            }

            p {
              font-size: 0.06em;
              color: #FFF;
              word-break: break-all;
            }
          }

          .threeBtn {
            position: absolute;
            right: 0.09em;
            bottom: 0.52em;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 999;

            .icon {
              width: 0.32em;
              height: 0.32em;
              background: url('../../assets/img/newMediaShare/bMain.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }

            .zan {
              width: 0.26em;
              height: 0.26em;
              background: url('../../assets/img/newMediaShare/zan.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              margin: 0.21em 0 0.24em;
            }

            .share {
              width: 0.26em;
              height: 0.26em;
              background: url('../../assets/img/newMediaShare/share.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }

          .bTop {
            position: absolute;
            top: 0.36em;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 0.07em;
            box-sizing: border-box;
            z-index: 999;

            i {
              display: block;
              width: 0.16em;
              height: 0.16em;

              &.back {
                background: url('../../assets/img/newMediaShare/back.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }

              &.search {
                background: url('../../assets/img/newMediaShare/search.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
              }
            }
          }

          video {
            width: 100%;
            height: auto;
          }
        }

        .bTop {
          
        }

        .phoneScroll {
          height: 100%;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 0px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(#dcdcdc, 0.3);
            border-radius: 0px;
          }

          img {
            max-width: 100% !important;
          }
        }

        .topLine {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 0.44em;
          z-index: 999;
        }
        .bottomLine {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.83em;
          z-index: 999;
        }

        video {
          width: 100%;
          height: 2.11em;
        }

        .title {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          min-height: 0.96em;
          padding: 0.15em 0.15em 0.1em;
          border-bottom: 2px solid #EEE;
          box-sizing: border-box;

          &>p {
            font-size: 0.18em;
            // line-height: 0.25em;
            color: #323B4B;      
            font-weight: bold;
          }

          div {
            display: flex;
            flex-direction: column;

            p {
              font-size: 0.12em;
              // line-height: 0.16em;
              color: #829191;

              &:nth-of-type(2) {
                margin-top: 0.03em;
              }
            }
          }
        }

        .content {
          padding: 0.1em 0.15em 0px;
          box-sizing: border-box;

          .article {
            font-size: 0.15em;
            // line-height: 0.24em;
            color: #323B4B;
          }

          .arrowLine {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 0.21em;

            p {
              width: 1.65em;
              height: 1px;
              background: #EEEEEE;
            }

            img {
              width: 0.12em;
              height: 0.1em;
              margin: 0 1px;
            }
          }
        }

        .notice {
          font-size: 0.15em;
          // line-height: 0.24em;
          color: #323B4B;
          margin-top: 2px;
          font-weight: 500;

          i {
            color: #E61939;
          }
        }

        .shareIcon {
          width: 100%;
          height: 0.78em;
          margin-top: 0.08em;
        }
      }
    }

    .pc-container {
      position: relative;
      width: 750px;
      height: 488px;
      background: #FFFFFF;
      box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
      border-radius: 4px;
      padding: 18px 0 20px;
      box-sizing: border-box;

      .close {
        position: absolute;
        top: -20px;
        right: -50px;
        width: 31px;
        height: 31px;
        user-select: none;
        cursor: pointer;
        z-index: 999;
      }

      .title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 77px;
        padding: 0 30px 8px;
        // border-bottom: 1px solid #EEEEEE;
        box-sizing: border-box;

        &>p {
          font-size: 18px;
          font-weight: bold;
          color: #323B4B;
          line-height: 25px;
        }

        &>div {
          display: flex;
          flex-direction: column;

          p {
            font-size: 12px;
            font-weight: 500;
            color: #829191;
            line-height: 17px;

            &:nth-of-type(2) {
              margin-top: 2px;
            }
          }
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 373px;
        padding: 20px 36px 0;
        overflow-y: auto;
        box-sizing: border-box;
        
          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 4px;
          }

        video {
          width: 468px;
          height: 264px;
          margin: 0 auto 20px;
        }

        .article {
          font-size: 14px;
          line-height: 24px;
          color: #323B4B;
        }
      }
    }

    .switch-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 30px;

      .btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 128px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 22px;
        user-select: none;
        cursor: pointer;

        &.b {
          img {
            width: 20px;
            height: 20px;
          }
        }

        &.un {
          opacity: 0.5;
        }

        img {
          width: 21px;
          height: 26px;
          margin-right: 9px;
        }

        p {
          font-size: 14px;
          line-height: 44px;
          color: #323B4B;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          margin-left: 30px;
        }
      }
    }

    .progress {
        position: absolute;
        left: 0;
        bottom: 0.2em;
        width: 100%;
        height: 2px;
        background: #666;

        .line {
          position: absolute;
          top: 0;
          left: 0;
          height: 2px;
          background: #FFF;
        }
      }

      .dy-container {
      display: flex;
      justify-content: center;
      align-items: center;
      max-height: 100%;
      max-width: 100%;
      overflow: hidden;
      background: #000;

      video {
        width: 100% !important;
        height: auto !important;
        max-height: calc(100vh - 1.68em);
      }

      .top {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.88em;
        background: url('../../assets/img/dy/top.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }

      .message {
        width: 2.65em;
        position: absolute;
        left: 0.12em;
        bottom: 0.93em;
        display: flex;
        flex-direction: column;
        color: #FFF;
        
        .name {
          font-size: 0.16em;
          font-weight: bold;
          margin-bottom: 0.08em;
        }

        .content {
          font-size: 0.13em;
          margin-bottom: 0.08em;

          .word {
            &.on {
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }

        .from {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 0.13em;
            height: 0.13em;
            margin-right: 0.04em;
          }

          span {
            font-size: 0.14em;
          }
        }
      }

      .btn {
        position: absolute;
        right: 0;
        bottom: 0.92em;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 0.51em;

        .avatar {
          display: flex;
          width: 0.51em;
          height: 0.51em;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 0.28em;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 0.2em;

          img {
            width: 0.39em;
            height: 0.39em;
            margin-bottom: 0.04em;
          }

          p {
            font-size: 0.13em;
            line-height: 0.15em;
            font-weight: bold;
            color: #FFF;
          }
        }

        .disk {
          position: relative;
          margin-top: -0.3em;

          .disk1 {
            width: 0.46em;
            height: 0.46em;
          }

          .sound {
            position: absolute;
            top: 0.6em;
            left: -0.41em;
            width: 0.61em;
            height: 0.66em;
          }
        }
      }

      .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.8em;
        background: url('../../assets/img/dy/bottom.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
    }
  }

  .copyright {
    color: #E61939;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }

  .threeShareIcon {
    width: 161px;
    height: 40px;
    position: absolute;
    top: 59px;
    right: 50px;
  }
</style>

<style lang="less">
  .phoneScroll {
    img,video {
      max-width: 100%;
    }
  }
</style>